import store from 'store2';

export default {
  get(key) {
    return store.local.get(key);
  },

  set(key, value) {
    return store.local.set(key, value);
  },

  getAll() {
    return store.local.getAll();
  },

  clearAll() {
    return store.clearAll();
  }
}



// WEBPACK FOOTER //
// ./src/helpers/storage.js